import _ from 'lodash';
import {
  getRequest,
  postRequest,
  patchRequest,
  deleteRequest,
  uploadEncodedFile
} from '../../Common/network-call';
import {
  INSTANCE_URL,
  FILES_URL,
  OFFSET_LIMIT_20
} from '../../Common/constant';

export const FETCH_ATTENDEE = 'FETCH_ATTENDEE';
export const OPEN_ATTENDEE_PROFILE = 'OPEN_ATTENDEE_PROFILE';
export const SHOW_BACK_SCREEN = 'SHOW_BACK_SCREEN';
export const MY_BOOKMARKED_USERS = 'MY_BOOKMARKED_USERS';
export const FILTER_LIST_OPEN = 'FILTER_LIST_OPEN';
export const MATCH_ATTENDEE_CATEGORY = 'MATCH_ATTENDEE_CATEGORY';

export const fetchAttendee = (
  session,
  pageCount = 0,
  dataArr = [],
  calledFromList = false,
  callback
) => {
  let perPage = OFFSET_LIMIT_20;
  let offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  let offSetQuery = `limit=${perPage}&offset=${offset}`;
  let orderby = 'username%20ASC';

  let filter = encodeURI(`(eventid=${session.eventid})`);
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?include_count=true&filter=(${filter})&${offSetQuery}&order=${orderby}${
    calledFromList ? '&attendee_list_true' : ''
  }`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        let localArr = data.resource;

        _.map(localArr, attendee => {
          let firstName = !_.isEmpty(attendee?.firstname)
            ? attendee?.firstname.trim()
            : 'G';
          let lastName = !_.isEmpty(attendee?.lastname)
            ? attendee?.lastname.trim()
            : 'U';

          attendee.firstname = firstName;
          attendee.lastname = lastName;
        });

        dispatch({
          type: FETCH_ATTENDEE,
          payload: {
            data: dataArr.concat(localArr),
            count: data.meta.count
          }
        });
        callback({
          success: 1,
          data: dataArr.concat(localArr),
          count: data.meta.count
        });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const searchAttendee = (
  session,
  search = '',
  pageCount = 0,
  dataArr = [],
  callback
) => {
  let perPage = OFFSET_LIMIT_20;
  let offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  let offSetQuery = `limit=${perPage}&offset=${offset}`;
  let orderby = 'username%20ASC';

  let filter = encodeURI(
    `(eventid=${session.eventid})AND((firstname CONTAINS ${search})OR(lastname CONTAINS ${search})OR(username CONTAINS ${search})OR(email CONTAINS ${search}))`
  );
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?include_count=true&filter=(${filter})&${offSetQuery}&order=${orderby}`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        //console.log('data: ', data);
        let localArr = data.resource;
        _.map(localArr, attendee => {
          let firstName = !_.isEmpty(attendee?.firstname)
            ? attendee?.firstname.trim()
            : 'G';
          let lastName = !_.isEmpty(attendee?.lastname)
            ? attendee?.lastname.trim()
            : 'U';

          attendee.firstname = firstName;
          attendee.lastname = lastName;
        });
        dispatch({
          type: FETCH_ATTENDEE,
          payload: {
            data: dataArr.concat(localArr),
            count: data.meta.count
          }
        });
        callback({
          success: 1,
          data: dataArr.concat(localArr),
          count: data.meta.count,
          currentsearch: localArr
        });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const clearAttendee = () => {
  return dispatch => {
    dispatch({ type: FETCH_ATTENDEE, payload: {} });
  };
};

export const fetchUserChatThread = (session, userid, callback) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND((receiverid=${session.userid})AND(senderid=${userid}))OR((receiverid=${userid})AND(senderid=${session.userid}))`
  );
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/chatthread?filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        // console.log('data: ', data);
        callback({ success: 1, data: data.resource });
      },
      error => {}
    );
  };
};

export const openAttendeeProfile = (obj, session = {}) => {
  return dispatch => {
    if (!_.isEmpty(session) && !_.isEmpty(obj.value)) {
      // console.log('api details..');
      dispatch(
        fetchUserChatThread(session, obj.value.appuserid, res => {
          obj.value.chatthread = res?.data?.length > 0 ? res.data : [];
          dispatch({ type: OPEN_ATTENDEE_PROFILE, payload: obj });
        })
      );
    } else {
      // console.log('blank details..');
      dispatch({ type: OPEN_ATTENDEE_PROFILE, payload: obj });
    }
  };
};

export const showBackScreen = value => {
  return dispatch => {
    dispatch({ type: SHOW_BACK_SCREEN, payload: value });
  };
};

export const fetchBookmarkedUsers = (session, callback) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(appuserid=${session.userid})ANDtype=user)`
  );
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/bookmarks?filter=(${filter})`;

  return dispatch => {
    dispatch({
      type: MY_BOOKMARKED_USERS,
      payload: {}
    });
    getRequest(
      url,
      session,
      dispatch,
      response => {
        // console.log('response :- ', response);
        dispatch({
          type: MY_BOOKMARKED_USERS,
          payload: { resource: response.resource }
        });
        callback({ success: 1, resource: response.resource });
      },
      error => {
        // callback({ success: 0, message: error });
      }
    );
  };
};

export const saveUserbookmark = (session, values, callback) => {
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/bookmarks`;
  let body = {
    resource: values
  };
  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        callback({ success: 1, response: response });
      },
      error => {
        callback({ success: 0 });
      }
    );
  };
};

export const deleteUserBookmark = (session, id, callback) => {
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/bookmarks/${id}`;

  return dispatch => {
    deleteRequest(
      url,
      session,
      dispatch,
      response => {
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0 });
      }
    );
  };
};

export const createChatThread = (session, values, callback) => {
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/chatthread`;
  let body = {
    resource: values
  };
  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        callback({ success: 1, response: response });
      },
      error => {
        callback({ success: 0 });
      }
    );
  };
};

export const uploadMedia = (session, uploadFiles, callback) => {
  // let filecontent = uploadFiles.file.replace(/^data:image\/[a-z]+;base64,/, ''); // only for image type file
  let filecontent = uploadFiles.file.split(';base64,')[1]; // for all type of file
  let filename = `eventify/${session.eventid}}/chatmedia/${uploadFiles.name}`;

  let mediaJson = {
    resource: [
      {
        name: filename,
        type: 'file',
        is_base64: true,
        content: filecontent
      }
    ]
  };
  return dispatch => {
    uploadEncodedFile(
      `${FILES_URL}?check_exist=false`,
      session,
      mediaJson,
      dispatch,
      response => {
        // console.log('response uploadMedia action: ', response);
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const openFilterListComponent = value => {
  return dispatch => {
    dispatch({ type: FILTER_LIST_OPEN, payload: value });
  };
};

export const matchAttendeeCategory = (session, payloadObj, callback) => {
  return dispatch => {
    dispatch({ type: MATCH_ATTENDEE_CATEGORY, payload: payloadObj }); // filter selections
    dispatch(clearAttendee()); // clears all attendee list
    dispatch(
      // filter API call
      fetchAttendeeByCategoryFilter(session, payloadObj, 0, [], res => {
        callback(res);
      })
    );
  };
};

export const resetAttendeeCategory = obj => {
  return dispatch => {
    dispatch({ type: MATCH_ATTENDEE_CATEGORY, payload: { count: 0 } });
  };
};

export const fetchAttendeeByCategoryFilter = (
  session,
  payloadObj = { cates: [] },
  pageCount = 0,
  dataArr = [],
  callback
) => {
  // --- creates array of ids of user group
  let categories = [];
  payloadObj.cates.length &&
    _.map(payloadObj.cates, item => {
      categories.push(`${item.id}`);
    });

  // --- filter formation
  let filter = `(eventid=${session.eventid})AND(usercategory CONTAINS `;
  _.map(categories, (cate, k) => {
    if (k == categories.length - 1) filter = `${filter}${cate})`;
    // for last id
    else filter = `${filter}${cate})OR(usercategory CONTAINS `; // before last id
  });

  // --- pagination and order param formation
  let perPage = OFFSET_LIMIT_20,
    offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage,
    offSetQuery = `limit=${perPage}&offset=${offset}`,
    orderby = 'username%20ASC';

  let fetchFilter = encodeURI(filter),
    fetchUrl = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?include_count=true&filter=(${fetchFilter})&${offSetQuery}&order=${orderby}`;

  return dispatch => {
    getRequest(
      fetchUrl,
      session,
      dispatch,
      data => {
        let localArr = data.resource;

        // --- checking for user name for guest user / name initial data population
        _.map(localArr, attendee => {
          let firstName = !_.isEmpty(attendee?.firstname)
            ? attendee?.firstname.trim()
            : 'G';
          let lastName = !_.isEmpty(attendee?.lastname)
            ? attendee?.lastname.trim()
            : 'U';

          attendee.firstname = firstName;
          attendee.lastname = lastName;
        });

        // --- appending filtered list to same attendee list reducer to avoid multiple conditions
        dispatch({
          type: FETCH_ATTENDEE,
          payload: {
            data: dataArr.concat(localArr),
            count: data.meta.count
          }
        });
        callback({
          success: 1,
          data: dataArr.concat(localArr),
          count: data.meta.count
        });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};
